import React from "react";
import SubjectiveQuestion from "./SubjectiveQuestion";
import BinaryPoll from "./BinaryPoll";
import MultiPoll from "./MultiPoll";
import RatingPoll from "./RatingPoll";

const Poll = (props) => {
  const { type = "" } = props;
  if (!type) return null;
  if (type === "SUBJECTIVE_QUESTION") return <SubjectiveQuestion {...props} />;
  if (type === "BINARY_POLL") return <BinaryPoll {...props} />;
  if (type === "MULTI_POLL") return <MultiPoll {...props} />;
  if (type === "RATING_POLL") return <RatingPoll {...props} />;
};

export default Poll;
